import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const TOKEN_KEY = 'sharepay_token';
const USER_KEY = 'sharepay_user';

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(TOKEN_KEY) || '',
    user: JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  },
  getters: {
    isLoggedIn: state => !!state.token,
    user: state => state.user
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      localStorage.setItem(TOKEN_KEY, token);
    },
    setUser(state, user) {
      state.user = user;
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    },
    logout(state) {
      state.token = '';
      state.user = null;
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    }
  },
  actions: {
    login({ commit }, { token, user }) {
      commit('setToken', token);
      commit('setUser', user);
    },
    logout({ commit }) {
      commit('logout');
    }
  }
});
